import React from "react";
import { WorkOrder } from "@model/workOrders/WorkOrder"
import { Routes } from "@lib/Routes"
import { Link } from "@lib/router/components"
import {ImageUrls} from "@ui/common/images/ImageUrls";
import {FormField} from "@ui/common/form/FormField";

export function WorkOrderNumber({assetId,id,number, onLinkClicked, isLink = true}: {assetId: number | null, id: number | null, number: string | null, onLinkClicked?: () => void, isLink?: boolean}): JSX.Element | null {
    return (<div className="work-order-number-component">                
                <div style={{marginLeft: "10px"}} ></div>{id && assetId ? <><div style={{marginRight: "5px"}}>Work Order</div> {isLink ? <Link to={Routes.NewWorkOrder(id.toString(), assetId?.toString())} onClick={onLinkClicked}>{number}</Link> : <span>{number}</span>} </> : <>PENDING</>}
        </div>);
}